// Normalizes the shape already built by src/utils/cortevaWorkbook.js and
// src/utils/cortevaManual.js, passed into approveCortevaInvoice(): {
// reimbursement, reimbursementBreakdown, serviceCharges, invoiceAmount,
// gstAmount, grossAmount }.
import { LINE_CATEGORIES, isKnownCategory, makeLine } from "../lineCategories";

const REIMBURSEMENT_DESCRIPTIONS = {
  [LINE_CATEGORIES.SALARY_REIMBURSEMENT]: "Salary reimbursement",
  [LINE_CATEGORIES.EOBI_RECOVERY]: "EOBI recovery",
  [LINE_CATEGORIES.PESSI_RECOVERY]: "PESSI recovery",
  [LINE_CATEGORIES.INSURANCE_RECOVERY]: "Health insurance recovery",
  [LINE_CATEGORIES.GLI_RECOVERY]: "GLI recovery"
};

export function normalizeCortevaInvoice(sourceDoc) {
  const serviceCharges = Number(sourceDoc.serviceCharges || 0);
  const reimbursement = Number(sourceDoc.reimbursement || 0);
  const gstAmount = Number(sourceDoc.gstAmount || 0);
  const grossAmount = Number(sourceDoc.grossAmount || 0);
  const invoiceAmount = Number(sourceDoc.invoiceAmount || (serviceCharges + reimbursement));

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: "Service charges", amount: serviceCharges, sourceField: "serviceCharges" })
  ];

  // Prefer a real category breakdown (EOBI, PESSI, insurance, etc.) when the
  // source workflow captured one; only collapse to one lump reimbursement
  // line for older data / flows that never captured the detail.
  const breakdown = sourceDoc.reimbursementBreakdown;
  const breakdownEntries = breakdown && typeof breakdown === "object"
    ? Object.entries(breakdown).filter(([category, amount]) => isKnownCategory(category) && Number(amount) > 0)
    : [];

  if (breakdownEntries.length) {
    breakdownEntries.forEach(([category, amount]) => {
      lines.push(makeLine({
        category,
        description: REIMBURSEMENT_DESCRIPTIONS[category] || category,
        amount: Number(amount),
        sourceField: "reimbursementBreakdown"
      }));
    });
  } else {
    lines.push(makeLine({ category: LINE_CATEGORIES.OTHER_REIMBURSEMENT, description: "Payroll cost reimbursement", amount: reimbursement, sourceField: "reimbursement" }));
  }

  lines.push(makeLine({ category: LINE_CATEGORIES.GST, description: "GST on service charges", amount: gstAmount, sourceField: "gstAmount" }));

  return {
    lines,
    serviceChargeSubtotal: serviceCharges,
    invoiceAmount,
    gstAmount,
    grossAmount,
    recoveryBase: null,
    recoveryAddBack: null
  };
}
